// src/components/sdk/SdkMgmtContent.tsx
import React from 'react';
import { Layout, message, Modal } from 'antd';
import { withTranslation } from 'react-i18next';
import { sdkMgmt } from '../../server/SdkMgmt';
import { ClientLogData, SdkAppData, SdkMgmtContentProps, SdkMgmtContentState, UsageLogData } from './SdkInterface';
import { AppDetailModal } from './AppDetailModal';
import { CreateAppModal } from './CreateAppModal';
import {
    TopHeader,
    SideMenu,
    ApiKeyContent,
    UsageContent,
    SdkDownloadContent
} from './components';
import { mockApps, mockLogs } from './SdkMock';
import i18n from '../../i18n';
import ClientLogContent from './components/ClientLogContent';
import axios from 'axios';
import { SdkApi } from '../../services/Api';

const { Content, Sider } = Layout;

class SdkMgmtContent extends React.Component<SdkMgmtContentProps, SdkMgmtContentState> {
    formRef = React.createRef<any>();
    usageFormRef = React.createRef<any>();

    constructor(props: SdkMgmtContentProps) {
        super(props);
        this.state = {
            searchText: '',
            isModalVisible: false,
            isDetailVisible: false,
            loading: false,
            detailLoading: false,
            appList: [],
            selectedApp: null,
            selectedMenu: 'apikey',
            usageLogs: [],
            clientLogs: [],
            usageTotal: 0,
            usageTotalUsage: 0,
            usagePage: 1,
            usagePageSize: 10,
            usageTotalPages: 0,
            usageLoading: false,
            usageFilter: {
                userId: undefined,
                appId: undefined,
                appName: undefined,
                startTime: undefined,
                endTime: undefined,
            },
            users: [],
            appBrief: [],
            isMobile: window.innerWidth <= 768,

            // 客户端日志专用分页 state
            clientLogPage: 1,
            clientLogPageSize: 10,
            clientLogTotal: 0,
            clientLogTotalPages: 0,
        } as any;
    }

    componentDidMount() {
        this.refreshAppList();
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => {
        this.setState({ isMobile: window.innerWidth <= 768 } as any);
    };

    // 获取用户信息
    getUserInfo = () => {
        try {
            const userStr = localStorage.getItem('sdk_user');
            if (userStr) {
                return JSON.parse(userStr);
            }
        } catch (e) {
            console.error('解析用户信息失败:', e);
        }
        return { email: '开发者', name: '开发者' };
    };

    // 从服务器获取应用列表
    getAppsFromServer = async (): Promise<SdkAppData[]> => {
        const DEBUG = true;
        const TAG = `SdkMgmtContent.getAppsFromServer()`;
        try {
            if (sdkMgmt?.getAppList) {
                const response = await sdkMgmt.getAppList();
                DEBUG && console.log(TAG, `response:\n`, response);
                if (response.success && response.data && response.data.list) {
                    return response.data.list.map((item: any) => ({
                        appId: item.id || item.appId,
                        key: item.id || item.appId,
                        appName: item.appName,
                        userName: item.userName,
                        packageName: item.packageName,
                        platform: item.platform || 'android',
                        status: item.status || 'active',
                        createTime: item.createTime,
                        endTime: item.endTime,
                        unlimited: item.unlimited,
                        totalQuota: item.totalQuota || 0,
                        usedQuota: item.usedQuota || 0,
                        remainingQuota: item.unlimited ? '∞' : (item.remainingQuota || 0),
                        appKey: item.appKey,
                        appSecret: item.appSecret,
                        description: item.description,
                    }));
                }
            }
        } catch (e) {
            console.error('获取应用列表失败:', e);
        }

        try {
            const appsStr = localStorage.getItem('sdk_apps');
            if (appsStr) {
                return JSON.parse(appsStr);
            }
        } catch (e) {
            console.error('解析应用列表信息失败:', e);
        }

        return [];//mockApps;
    };

    // 刷新应用列表
    refreshAppList = async () => {
        const DEBUG = true;
        const TAG = `SdkMgmtContent.refreshAppList()`;
        this.setState({ loading: true } as any);
        try {
            const appList = await this.getAppsFromServer();
            DEBUG && console.log(TAG, `appList:\n`, appList);
            this.setState({ appList } as any);
        } catch (error) {
            message.error(this.props.t('sdk.app.refreshFailed') || '刷新应用列表失败');
        } finally {
            this.setState({ loading: false } as any);
        }
    };

    // 获取使用记录（支持过滤参数）
    getUsageLogs = async (page: number = 1, pageSize: number = 10, filter?: any) => {
        const DEBUG = true;
        const TAG = `SdkMgmtContent.getUsageLogs()`;
        DEBUG && console.log(TAG, `page:`, page);
        DEBUG && console.log(TAG, `pageSize:`, pageSize);
        DEBUG && console.log(TAG, `filter:`, filter);

        const { t } = this.props;

        this.setState({ usageLoading: true } as any);

        const currentFilter = (this.state as any).usageFilter;
        const finalFilter = { ...currentFilter, ...filter };

        try {
            let type = 0;
            let userId = finalFilter.userId || 0;
            let appId = finalFilter.appId || 0;
            let appName = finalFilter.appName || '';
            let startTime = finalFilter.startTime || '';
            let endTime = finalFilter.endTime || '';

            const response = await sdkMgmt.getLogList(
                type,
                userId,
                appId,
                appName,
                page,
                pageSize,
                startTime,
                endTime
            );

            DEBUG && console.log(TAG, `response:\n`, response);

            if (response.success) {
                let logs = []
                for (let i = 0; i < response.data.logs.length; i++) {
                    const log = response.data.logs[i];
                    const consumerInfo = JSON.parse(log.consumerInfo);
                    logs.push({
                        id: log.id,
                        type: log.type,
                        userId: log.userId,
                        appId: log.appId,
                        appName: log.appName,
                        packageName: log.packageName,
                        usageTime: log.callTime,
                        totalQuota: log.totalQuota,
                        usedQuota: log.usedQuota,
                        remainingQuota: log.remainingQuota,
                        consumerInfo: log.consumerInfo,
                        userName: 'TODO',
                        deviceType: consumerInfo.deviceType || 'unknown',
                        mac: consumerInfo.mac || 'unknown',
                    })
                }

                const total = response.data.total;
                const totalUsage = response.data.totalUsage;
                const totalPages = response.data.totalPages;

                this.setState({
                    usageLogs: logs,
                    usageTotal: total,
                    usageTotalUsage: totalUsage,
                    usagePage: page,
                    usagePageSize: pageSize,
                    usageTotalPages: totalPages,
                    users: response.data.users,
                    appBrief: response.data.appBrief,
                } as any);
            }
            else {
                await new Promise((resolve) => setTimeout(resolve, 500));

                let logs: UsageLogData[] = [];

                if (finalFilter.userId) {
                    logs = logs.filter(log => log.userId === finalFilter.userId);
                }
                if (finalFilter.appName) {
                    logs = logs.filter(log => log.appName === finalFilter.appName);
                }
                if (finalFilter.startTime) {
                    logs = logs.filter(log => log.usageTime >= finalFilter.startTime);
                }
                if (finalFilter.endTime) {
                    logs = logs.filter(log => log.usageTime <= finalFilter.endTime);
                }

                const total = logs.length;
                const totalUsage = logs.reduce((sum, log) => sum + log.usedQuota, 0);
                const totalPages = Math.ceil(total / pageSize);

                this.setState({
                    usageLogs: logs,
                    usageTotal: total,
                    usageTotalUsage: totalUsage,
                    usagePage: page,
                    usagePageSize: pageSize,
                    usageTotalPages: totalPages,
                } as any);
            }

        } catch (error) {
            console.error('获取使用记录失败:', error);
            message.error(this.props.t('sdk.usage.fetchFailed') || '获取使用记录失败');
        } finally {
            this.setState({ usageLoading: false } as any);
        }
    };

    /** 获取客户端调试日志 */
    getClientLogs = async (page: number = 1, pageSize: number = 10, filter?: any) => {
        const DEBUG = true;
        const TAG = `SdkMgmtContent.getClientLogs()`;
        DEBUG && console.log(TAG, `page:`, page);
        DEBUG && console.log(TAG, `pageSize:`, pageSize);
        DEBUG && console.log(TAG, `filter:`, filter);

        this.setState({ usageLoading: true } as any);

        try {
            const response = await sdkMgmt.getClientLogs(page, pageSize);

            DEBUG && console.log(TAG, `response:\n`, response);

            if (response.success) {
                // 直接映射服务端返回的 ClientLogResponse 结构
                const logs: ClientLogData[] = (response.data.list || []).map((log: any) => ({
                    id: log.id,
                    packageName: log.packageName,
                    userName: log.userName,
                    logDate: log.logDate,
                    logSize: log.logSize,
                    updateTime: log.updateTime,
                    source: log.source,
                }));

                const totalRecords = response.data.totalRecords || 0;
                const totalPages = response.data.totalPages || 0;
                const currentPage = response.data.currentPage || 1;

                this.setState({
                    clientLogs: logs,
                    clientLogPage: currentPage,
                    clientLogPageSize: pageSize,
                    clientLogTotal: totalRecords,
                    clientLogTotalPages: totalPages,
                } as any);
            } else {
                // 失败兜底：空列表
                await new Promise((resolve) => setTimeout(resolve, 500));

                this.setState({
                    clientLogs: [],
                    clientLogPage: page,
                    clientLogPageSize: pageSize,
                    clientLogTotal: 0,
                    clientLogTotalPages: 0,
                } as any);
            }
        } catch (error) {
            console.error('获取客户端日志失败:', error);
            message.error(this.props.t('sdk.log.fetchFailed') || '获取客户端日志失败');
        } finally {
            this.setState({ usageLoading: false } as any);
        }
    };

    // 获取应用详情
    getAppDetail = async (app: SdkAppData) => {
        this.setState({ detailLoading: true, selectedApp: app, isDetailVisible: true } as any);
        try {
            if (sdkMgmt?.getAppDetail && app.key) {
                const response = await sdkMgmt.getAppDetail(app.key);
                if (response.success && response.data) {
                    this.setState({
                        selectedApp: {
                            ...app,
                            ...response.data,
                        },
                    } as any);
                }
            }
        } catch (error) {
            console.error('获取应用详情失败:', error);
        } finally {
            this.setState({ detailLoading: false } as any);
        }
    };

    // 处理创建应用
    handleCreateApp = async () => {
        const DEBUG = true;
        const TAG = `SdkMgmtContent.handleCreateApp() - `;
        const { t } = this.props;
        try {
            const form = this.formRef.current;
            if (!form) return;

            const values = await form.validateFields();
            DEBUG && console.log(TAG, `values:\n`, values);
            this.setState({ loading: true } as any);

            let { appName, packageName, initialQuota, unlimited, expireTime, platform, description } = values;

            expireTime = expireTime.format('YYYY-MM-DD HH:mm:ss');
            DEBUG && console.log(TAG, `initialQuota:`, initialQuota);
            DEBUG && console.log(TAG, `unlimited:`, unlimited);
            DEBUG && console.log(TAG, `expireTime:`, expireTime);

            if (sdkMgmt?.initApp) {
                const response = await sdkMgmt.initApp(platform, appName, packageName, initialQuota, unlimited, expireTime, description);

                if (response.success) {
                    message.success({
                        content: t('sdk.app.createSuccess', { appName }) || `应用 "${appName}" 创建成功！`,
                        duration: 3,
                    });
                    this.setState({ isModalVisible: false } as any);
                    form.resetFields();
                    await this.refreshAppList();
                } else {
                    const errorMsg = response.message || t('sdk.app.createFailed') || '创建应用失败，请稍后重试';
                    message.error(errorMsg);
                }
            } else {
                await new Promise((resolve) => setTimeout(resolve, 1500));

                const newApp: SdkAppData = {
                    appId: Date.now(),
                    key: Date.now().toString(),
                    appName,
                    packageName,
                    platform,
                    status: 'active',
                    createTime: new Date().toLocaleString('zh-CN'),
                    endTime: new Date().toLocaleString('zh-CN'),
                    unlimited: 0,
                    totalQuota: 2000,
                    usedQuota: 0,
                    remainingQuota: 2000,
                    description: description || '',
                };

                const existingApps = (this.state as any).appList;
                const updatedApps = [newApp, ...existingApps];
                localStorage.setItem('sdk_apps', JSON.stringify(updatedApps));

                message.success({
                    content: t('sdk.app.createSuccess', { appName }) || `应用 "${appName}" 创建成功（模拟）！`,
                    duration: 3,
                });
                this.setState({ isModalVisible: false } as any);
                form.resetFields();
                await this.refreshAppList();
            }
        } catch (error: any) {
            if (error.errorFields) {
                return;
            }
            const errorMsg = error.message || this.props.t('sdk.app.createFailed') || '创建应用失败，请稍后重试';
            message.error(errorMsg);
        } finally {
            this.setState({ loading: false } as any);
        }
    };

    // 打开弹框
    showModal = () => {
        this.setState({ isModalVisible: true } as any);
        const form = this.formRef.current;
        if (form) {
            form.resetFields();
        }
    };

    // 关闭弹框
    handleCancel = () => {
        this.setState({ isModalVisible: false } as any);
        const form = this.formRef.current;
        if (form) {
            form.resetFields();
        }
    };

    // 关闭详情弹框
    handleDetailClose = () => {
        this.setState({ isDetailVisible: false, selectedApp: null } as any);
    };

    // 购买API调用次数
    onQuotaIncrease = async (appId: number, priceId: number, addQuota: number): Promise<any> => {
        const DEBUG = true;
        const TAG = `SdkMgmtContent.onQuotaIncrease() - `;
        let response = await sdkMgmt.buyQuota(appId, priceId, addQuota);
        DEBUG && console.log(TAG, `response:\n`, response);
        if (response && response.success) {
            const responseData = response.data;
            DEBUG && console.log(TAG, `responseData:\n`, responseData);
            if (responseData) {
                const appList = (this.state as any).appList;
                for (let i = 0; i < appList.length; i++) {
                    const app: SdkAppData = appList[i];
                    if (app.appId == responseData.appId) {
                        app.totalQuota = responseData.totalQuota;
                        app.remainingQuota = responseData.remainingQuota;
                        break;
                    }
                }
                this.setState({ appList: appList } as any);
                return responseData;
            }
        }
    }

    // 处理配额增加（用于AppDetailModal）
    handleQuotaIncrease = async (appId: number, priceId: number, addQuota: number): Promise<any> => {
        return this.onQuotaIncrease(appId, priceId, addQuota);
    };

    // 处理应用更新
    handleUpdateApp = (updatedApp: SdkAppData) => {
        const { appList } = this.state as any;
        const updatedList = appList.map((app: SdkAppData) =>
            app.appId === updatedApp.appId ? { ...app, ...updatedApp } : app
        );
        this.setState({
            appList: updatedList,
            selectedApp: updatedApp,
        } as any);
    };

    // 加载应用列表（刷新）
    loadAppList = async () => {
        await this.refreshAppList();
    };

    // 处理搜索 - 实时搜索，更新searchText即可，过滤由ApiKeyContent内部完成
    handleSearch = (value: string) => {
        this.setState({ searchText: value } as any);
    };

    // 处理搜索文本变化
    handleSearchTextChange = (text: string) => {
        this.setState({ searchText: text } as any);
        this.handleSearch(text);
    };

    // 处理过滤器重置
    handleFilterReset = () => {
        if (this.usageFormRef.current) {
            this.usageFormRef.current.resetFields();
        }

        this.setState({
            usageFilter: {
                userId: undefined,
                appId: undefined,
                appName: undefined,
                startTime: undefined,
                endTime: undefined,
            }
        } as any, () => {
            this.getUsageLogs(1, (this.state as any).usagePageSize);
        });
    };

    // 处理过滤器应用
    handleFilterApply = (values: any) => {
        const filter: any = {};

        if (values.userId) {
            filter.userId = values.userId;
        }
        if (values.appName) {
            filter.appName = values.appName;
        }
        if (values.appId) {
            filter.appId = values.appId;
        }
        if (values.timeRange && values.timeRange.length === 2) {
            filter.startTime = values.timeRange[0].format('YYYY-MM-DD HH:mm:ss');
            filter.endTime = values.timeRange[1].format('YYYY-MM-DD HH:mm:ss');
        }

        this.setState({
            usageFilter: filter
        } as any, () => {
            this.getUsageLogs(1, (this.state as any).usagePageSize);
        });
    };

    // 处理刷新
    handleRefresh = () => {
        const { t } = this.props;
        const state: any = this.state;
        if (state.selectedMenu === 'apikey') {
            this.refreshAppList();
        } else if (state.selectedMenu === 'usage') {
            this.getUsageLogs(state.usagePage, state.usagePageSize);
        } else if (state.selectedMenu === 'log') {
            this.getClientLogs(state.clientLogPage, state.clientLogPageSize);
        }
        if (state.selectedMenu !== 'download') {
            message.success(t('sdk.app.refreshSuccess') || '已刷新');
        }
    };

    // 处理切换应用状态（禁用/激活）
    handleToggleStatus = async (record: SdkAppData) => {
        const { t } = this.props;
        const isActive = record.status === 'active';
        const action = isActive ? '禁用' : '激活';

        try {
            let response;
            if (isActive) {
                response = await sdkMgmt.inactivateApp(record.appId);
            } else {
                response = await sdkMgmt.activateApp(record.appId);
            }

            if (response && response.success) {
                message.success(t(`sdk.app.${isActive ? 'disable' : 'activate'}Success`) || `${action}成功`);
                await this.refreshAppList();
            } else {
                message.error(response?.message || t('sdk.app.toggleStatusFailed') || `${action}失败`);
            }
        } catch (error) {
            console.error('切换应用状态失败:', error);
            message.error(t('sdk.app.toggleStatusFailed') || `${action}失败`);
        }
    };

    // 处理删除应用
    handleDeleteApp = (record: SdkAppData) => {
        const { t } = this.props;

        Modal.confirm({
            title: t('sdk.app.deleteConfirm') || '确认删除',
            content: t('sdk.app.deleteConfirmContent', { appName: record.appName }) || `确定要删除应用 "${record.appName}" 吗？此操作不可恢复。`,
            okText: t('sdk.app.delete') || '删除',
            cancelText: t('sdk.app.cancel') || '取消',
            okType: 'danger',
            onOk: async () => {
                try {
                    const response = await sdkMgmt.deleteApp(record.appId);
                    if (response && response.success) {
                        message.success(t('sdk.app.deleteSuccess') || '删除成功');
                        await this.refreshAppList();
                    } else {
                        message.error(response?.message || t('sdk.app.deleteFailed') || '删除失败');
                    }
                } catch (error) {
                    console.error('删除应用失败:', error);
                    message.error(t('sdk.app.deleteFailed') || '删除失败');
                }
            },
        });
    };

    // 处理菜单切换
    handleMenuClick = (e: any) => {
        const key = e.key;
        this.setState({ selectedMenu: key } as any);
        if (key === 'usage') {
            this.getUsageLogs(1, 10);
        } else if (key === 'log') {
            this.getClientLogs(1, 10);
        }
    };

    // 处理语言切换
    handleLanguageChange = (lang: string) => {
        i18n.changeLanguage(lang);
        localStorage.setItem('lang', lang);
    };

    // 渲染内容区域
    renderContent = () => {
        const { t } = this.props;
        const state: any = this.state;
        const { selectedMenu, appList, loading, searchText, users, appBrief, isMobile } = state;

        switch (selectedMenu) {
            case 'apikey':
                return (
                    <ApiKeyContent
                        t={t}
                        appList={appList}
                        loading={loading}
                        searchText={searchText}
                        onSearchTextChange={this.handleSearchTextChange}
                        onSearch={this.handleSearch}
                        onRefresh={this.handleRefresh}
                        onCreateApp={this.showModal}
                        onGetAppDetail={this.getAppDetail}
                        onToggleStatus={this.handleToggleStatus}
                        onDeleteApp={this.handleDeleteApp}
                        isMobile={isMobile}
                    />
                );
            case 'usage':
                return (
                    <UsageContent
                        t={t}
                        usageLogs={state.usageLogs}
                        usageTotal={state.usageTotal}
                        usageTotalUsage={state.usageTotalUsage}
                        usagePage={state.usagePage}
                        usagePageSize={state.usagePageSize}
                        usageTotalPages={state.usageTotalPages}
                        usageLoading={state.usageLoading}
                        usageFilter={state.usageFilter}
                        onRefresh={this.handleRefresh}
                        onFilterApply={this.handleFilterApply}
                        onFilterReset={this.handleFilterReset}
                        onPageChange={this.getUsageLogs}
                        usageFormRef={this.usageFormRef}
                        users={users}
                        appBrief={appBrief}
                        isMobile={isMobile}
                    />
                );
            case 'download':
                return <SdkDownloadContent t={t} isMobile={isMobile} />;
            case 'log':
                return (
                    <ClientLogContent
                        t={t}
                        clientLogs={state.clientLogs}
                        clientLogsTotal={state.clientLogTotal}
                        clientLogsPage={state.clientLogPage}
                        clientLogsPageSize={state.clientLogPageSize}
                        clientLogsTotalPages={state.clientLogTotalPages}
                        clientLogsLoading={state.usageLoading}
                        clientLogsFilter={state.usageFilter}
                        onRefresh={this.handleRefresh}
                        onFilterApply={this.handleFilterApply}
                        onFilterReset={this.handleFilterReset}
                        onPageChange={this.getClientLogs}
                        clientLogsFormRef={this.usageFormRef}
                        isMobile={isMobile}
                        onDeleteLog={async (id) => {
                            await axios.post(SdkApi.DEL_SDK_LOG, {
                                ids: [Number(id)],
                                token: localStorage.getItem('token'),
                                role: localStorage.getItem('role'),
                                lang: (localStorage.getItem('lang') || 'zh_CN').split('_')[0],
                            });
                        }}
                    />
                );
            default:
                return null;
        }
    };

    render() {
        const { t } = this.props;
        const state: any = this.state;
        const {
            selectedMenu,
            isModalVisible,
            isDetailVisible,
            selectedApp,
            detailLoading,
            loading,
            isMobile
        } = state;

        const siderWidth = isMobile ? 0 : 200;
        const contentMarginLeft = isMobile ? 0 : 200;
        const contentPadding = isMobile ? '12px' : '24px 24px 24px 24px';

        return (
            <Layout style={{
                height: '100vh',
                background: '#f0f2f5',
                maxWidth: '100%',
                margin: '0 auto',
                width: '100%',
                overflow: 'hidden',
            }}>
                {/* TopHeader 固定顶部 */}
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    zIndex: 1000,
                    height: 64,
                }}>
                    <TopHeader
                        t={t}
                        userInfo={this.getUserInfo()}
                        onLanguageChange={this.handleLanguageChange}
                        onLogout={this.props.onLogout}
                        isMobile={isMobile}
                    />
                </div>

                <Layout style={{
                    marginTop: 64,
                    height: 'calc(100vh - 64px)',
                    overflow: 'hidden',
                }}>
                    {/* Sider 固定左侧 - 移动端隐藏 */}
                    {!isMobile && (
                        <div style={{
                            position: 'fixed',
                            left: 0,
                            top: 64,
                            bottom: 0,
                            width: siderWidth,
                            zIndex: 999,
                            background: '#fff',
                            borderRight: '1px solid #e8e8e8',
                            overflow: 'auto',
                        }}>
                            <SideMenu
                                selectedKey={selectedMenu}
                                onMenuClick={this.handleMenuClick}
                                t={t}
                            />
                        </div>
                    )}

                    {/* 移动端底部导航 */}
                    {isMobile && (
                        <div style={{
                            position: 'fixed',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            zIndex: 999,
                            background: '#fff',
                            borderTop: '1px solid #e8e8e8',
                            display: 'flex',
                            justifyContent: 'space-around',
                            padding: '8px 0',
                            paddingBottom: 'env(safe-area-inset-bottom)',
                            height: 56,
                        }}>
                            {['apikey', 'usage', 'log', 'download'].map((key) => {
                                const iconMap: Record<string, string> = {
                                    apikey: '🔑',
                                    usage: '📊',
                                    log: '📄',
                                    download: '📥',
                                };
                                const labelMap: Record<string, string> = {
                                    apikey: t('sdk.menu.apikey') || 'API密钥',
                                    usage: t('sdk.menu.usage') || '使用记录',
                                    log: t('sdk.menu.log') || '日志管理',
                                    download: t('sdk.menu.download') || 'SDK下载',
                                };
                                return (
                                    <div
                                        key={key}
                                        onClick={() => {
                                            this.setState({ selectedMenu: key } as any);
                                            if (key === 'usage') {
                                                this.getUsageLogs(1, 10);
                                            } else if (key === 'log') {
                                                this.getClientLogs(1, 10);
                                            }
                                        }}
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            cursor: 'pointer',
                                            padding: '4px 12px',
                                            color: selectedMenu === key ? '#667eea' : '#999',
                                            fontSize: 12,
                                        }}
                                    >
                                        <span style={{ fontSize: 20 }}>{iconMap[key]}</span>
                                        <span style={{ marginTop: 2 }}>{labelMap[key]}</span>
                                    </div>
                                );
                            })}
                        </div>
                    )}

                    {/* 右侧内容区域 - 可滚动 */}
                    <Layout style={{
                        marginLeft: contentMarginLeft,
                        padding: contentPadding,
                        background: '#f0f2f5',
                        flex: 1,
                        height: '100%',
                        overflow: 'auto',
                        paddingBottom: isMobile ? 72 : undefined,
                    }}>
                        <Content style={{
                            background: '#fff',
                            padding: isMobile ? 16 : 24,
                            borderRadius: isMobile ? 8 : 12,
                            minHeight: 280,
                            maxWidth: '100%',
                            width: '100%',
                            paddingBottom: isMobile ? 24 : 24,
                        }}>
                            {this.renderContent()}
                        </Content>
                    </Layout>
                </Layout>

                <CreateAppModal
                    visible={isModalVisible}
                    loading={loading}
                    onOk={this.handleCreateApp}
                    onCancel={this.handleCancel}
                    t={t}
                    formRef={this.formRef}
                    isMobile={isMobile}
                />

                <AppDetailModal
                    visible={isDetailVisible}
                    app={selectedApp}
                    loading={detailLoading}
                    onClose={this.handleDetailClose}
                    t={t}
                    onQuotaIncrease={this.handleQuotaIncrease}
                    onUpdateApp={this.handleUpdateApp}
                    onRefreshList={this.loadAppList}
                    isMobile={isMobile}
                />
            </Layout>
        );
    }
}

export default withTranslation()(SdkMgmtContent);